export const colors = {
  // Blue
  blue1: "#090979",
  blue2: "#020024",
  blue3: "#00D4FF",
  blue4: "#243A48",
  blue5: "#214a63",
  blue6: "#5F7FDB",
  blue7: "#0DDCFE",
  blue8: "#123696",
  blue9: "#13A0DD",
  blue10: "#2A3A43",
  blue11: "#1C282D",
  blue12: "#2789CE",
  blue13: "#72BBEF",
  blue14: "#243948",
  blue15: "#D7E8F4",
  blue16: "#B7D5EB",
  blue17: "#BED5D8",
  blue18: "#315195",
  blue19: "#BEDDF4",
  blue20: "#00D0FC",
  blue21: "#1766B7",
  blue22: "#050447",
  blue23: "#020028",
  blue24: "#1A3DA6",
  blue25: "#6274C6",
  blue26: "#1CD6FC",
  blue27: "#52B6FE",
  blue28: "#6154FE",
  blue29: "rgba(82, 182, 254, 0.8)",
  blue30: "rgba(97, 84, 254, 0.8)",
  blue31: "#0F2462",
  blue32: "#00c6f3",
  blue33: "#1B282D",
  casinoProvidersBorder: "#A9A9A9",

  // Teal
  teal1: "#095964",
  teal2: "#E3FCFF75",

  // Gray
  gray1: "#EDEDED",
  gray2: "#ADB5BD",
  gray3: "#E4E4E4",
  gray4: "#66697C",
  gray5: "#6C757D",
  gray6: "#C8CED3",
  gray7: "#B2B2B2",
  gray8: "#C5D0D7",
  gray9: "#989EA1",
  gray10: "#CED5DA",
  gray11: "#EEEEEE",
  gray12: "#A5A5A5",
  gray13: "#7E97A7",
  gray14: "#E4E7EA",
  gray15: "#A4A4A4",
  gray16: "#CED4DA",
  gray17: "#DDDDDD",
  gray18: "#C8CED2",
  gray19: "#BBBBBB",
  gray20: "#F2F2F2",
  gray21: "#C7C8CA",
  oneClickLoadingSpinner: "#ffffff4d",

  // Black
  black1: "#212121",
  black2: "#0000004D",
  black3: "#404040",
  black4: "#333333",
  black5: "#222222",

  // Red
  red1: "#F72424",
  red2: "#f50202",
  red3: "#f53d3d",
  red4: "#A23601",
  red5: "#BB1C00",
  red6: "#D61F13",
  red7: "#FF0000",
  red8: "#9E1604",
  red9: "#D63D32",
  red10: "#AA301C",
  // Green
  green1: "#6BBD11",
  green2: "#69943A",
  green3: "#508D0E",
  green4: "#00A105",
  green5: "#008000",
  popularEventDateBg: "#167122",

  // Pink
  pink1: "#FAA9BA",
  pink2: "#EFD3D9",
  pink3: "#F6E6EA",

  // Yellow
  yellow1: "#FAF8D8",
  yellow2: "#FFE4B4",
  yellow3: "#FFFF00",
  goldenYellow: "#ffb80c",

  // Peach
  peach1: "#FF6A6A",
};
